export const DoppeActionTypeProductViewerLang = {
    defaultTexts: {
        productTitle: 'Product Name',
        description: 'Describe the product you want to sell',
        productButtonText: 'Buy Now',
        price: '$10'
    }
}